/**
 * ScheduleContentSheet
 *
 * Promise-based sheet wrapper for the schedule content flow.
 * Follows ConfirmSheet pattern — presents ScheduleContentContent via SheetService.
 * Matches Flutter's ScheduleContentScreen presented as a bottom sheet.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import {
  ScheduleContentContent,
  type ScheduleContentSheetResult,
} from './ScheduleContentContent';

export interface ScheduleContentSheetConfig {
  title: string;
  initialSchedule?: number | null;
  screenKey?: string;
}

const show = (config: ScheduleContentSheetConfig): Promise<ScheduleContentSheetResult | null> => {
  return new Promise((resolve) => {
    let resolved = false;

    const handleResolve = (result: ScheduleContentSheetResult | null) => {
      if (!resolved) {
        resolved = true;
        resolve(result);
      }
    };

    const handleDismiss = () => {
      if (!resolved) {
        resolved = true;
        resolve(null);
      }
    };

    SheetService.show({
      content: (
        <ScheduleContentContent
          initialSchedule={config.initialSchedule}
          onResolve={handleResolve}
        />
      ),
      title: config.title,
      onClose: handleDismiss,
      container: config.screenKey,
      screenKey: config.screenKey,
      closeOnClickOutside: true,
    });
  });
};

export const ScheduleContentSheet = {
  show,
};
